export function formatDate(data, formatStr) {
	if(!formatStr || typeof formatStr != 'string') formatStr = "yyyy-MM-dd HH:mm";
	var date = data;
	switch(typeof data) {
		case "string":
			if(navigator.userAgent.indexOf('Firefox') > -1 || (!!window.ActiveXObject || "ActiveXObject" in window)) {
				date = new Date(data.replace(/ /g, 'T').replace(/\//g, "-"));
			} else {
				date = new Date(data.replace(/T/g, ' ').replace(/-/g, "/"));
			}
			break;
		case "number":
			date = new Date(data);
			break;
	}
	if(!(date instanceof Date))
		return data;
	var dict = {
		"yyyy": date.getFullYear(),
		"M": date.getMonth() + 1,
		"d": date.getDate(),
		"H": date.getHours(),
		"m": date.getMinutes(),
		"s": date.getSeconds(),
		"MM": ("" + (date.getMonth() + 101)).substr(1),
		"dd": ("" + (date.getDate() + 100)).substr(1),
		"HH": ("" + (date.getHours() + 100)).substr(1),
		"mm": ("" + (date.getMinutes() + 100)).substr(1),
		"ss": ("" + (date.getSeconds() + 100)).substr(1)
	};
	return formatStr.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
		return dict[arguments[0]];
	});
}

export function toDate(strDate) {
	let date;
	if(navigator.userAgent.indexOf('Firefox') > -1 || (!!window.ActiveXObject || "ActiveXObject" in window)) {
		date = new Date(strDate.replace(/ /g, 'T').replace(/\//g, "-"));
	} else {
		date = new Date(strDate.replace(/T/g, ' ').replace(/-/g, "/"));
	}
	return date;
}
export function getSTCDTypeTable($this, stcd) {	
	let pointType = '1'
	let isRain = $this.$store.state.warnmonitor.rainInfo.some(item => {
		return item.STCD == stcd
	})
	let isRiver = $this.$store.state.warnmonitor.riverInfo.some(item => {
		return item.STCD == stcd
	})
	let isRsvr = $this.$store.state.warnmonitor.rsvrInfo.some(item => {
		return item.STCD == stcd
	})
	let isImg = $this.$store.state.warnmonitor.imgInfo.some(item => {
		return item.STCD == stcd
	})
	if(isImg && isRain && isRsvr) pointType = '10'
	else if(isImg && isRain && isRiver) pointType = '9'
	else if(isImg && isRsvr) pointType = '8'
	else if(isImg && isRiver) pointType = '7'
	else if(isImg && isRain) pointType = '6'

	else if(isRain && isRsvr) pointType = '5'
	else if(isRain && isRiver) pointType = '4'
	else if(isRsvr) pointType = '3'
	else if(isRiver) pointType = '2'
	else if(isRain) pointType = '1'
	return pointType
}


// WEBPACK FOOTER //
// ./src/assets/util/common.js